module.exports = __webpack_public_path__ + "static/media/footwear-8.1849d660.jpg";